import { useQuery } from '@tanstack/react-query';

import loyaltyFlow from '../../common/flow/loyaltyFlow';
import { pointsQueryKeys } from '../../member/pointshop/pointsQueryKeys';
import { useIsEligibleForNewBonusSystem } from './useIsEligibleForNewBonusSystem';

export const bonusLevelTimelineSummaryQueryOptions = ({
    beId,
    isAuthenticated,
    enabled,
}: {
    beId?: string;
    isAuthenticated: boolean;
    enabled: boolean;
}) => ({
    queryKey: pointsQueryKeys.bonusLevelTimelineSummary(beId, isAuthenticated),
    queryFn: loyaltyFlow.getBonusLevelTimelineSummary,
    staleTime: 1000 * 60 * 60,
    enabled,
    retry: false,
});

export const useBonusLevelTimelineSummaryQuery = ({ enabled }: { enabled?: boolean } = {}) => {
    const { beId, isAuthenticated, isEligibleForNewBonusSystem } = useIsEligibleForNewBonusSystem();

    return useQuery(
        bonusLevelTimelineSummaryQueryOptions({
            beId,
            isAuthenticated,
            enabled: enabled ?? isEligibleForNewBonusSystem,
        }),
    );
};
